<template>
    <div>
        <label
            class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
        >
            {{ label }}
        </label>
        <select
            :value="modelValue === undefined ? '' : modelValue"
            @change="
                $emit(
                    'update:modelValue',
                    parseValue(($event.target as HTMLSelectElement).value),
                )
            "
            class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
        >
            <option value="">{{ allLabel }}</option>
            <option
                v-for="option in normalizedOptions"
                :key="String(option.value)"
                :value="option.value"
            >
                {{ option.label }}
            </option>
        </select>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface StatusOption {
    value: string | boolean;
    label: string;
}

const props = withDefaults(
    defineProps<{
        modelValue?: string | boolean | undefined;
        label?: string;
        allLabel?: string;
        options?: StatusOption[];
    }>(),
    {
        label: "Status",
        allLabel: "All",
        options: () => [
            { value: true, label: "Active" },
            { value: false, label: "Inactive" },
        ],
    },
);

defineEmits<{
    "update:modelValue": [value: string | boolean | undefined];
}>();

const normalizedOptions = computed(() => props.options);

const parseValue = (val: string): string | boolean | undefined => {
    if (val === "undefined" || val === "") return undefined;
    if (val === "true") return true;
    if (val === "false") return false;
    return val;
};
</script>
